import React from 'react';
import { constructorWhatsapp } from '../utils/utils';
import { numVentaPrincipal, numVentasPrincipal, portalClientes } from '../config/constant';

const Hero = () => {
  return (
    <section id="hero" className="bg-gradient-to-b from-blue-50 via-white to-white py-12 md:py-20 px-6 lg:px-16 flex flex-col lg:flex-row items-center justify-between gap-12 overflow-hidden">
      
      {/* COLUMNA IZQUIERDA: PROPUESTA DE VALOR */}
      <div className="max-w-2xl text-center lg:text-left z-10">
        <span className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold px-4 py-1.5 rounded-full mb-6 mx-auto lg:mx-0 w-fit">
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.6 9h16.8M3.6 15h16.8M12 3a15.3 15.3 0 014.5 9 15.3 15.3 0 01-4.5 9 15.3 15.3 0 01-4.5-9 15.3 15.3 0 014.5-9z" />
          </svg>
          Presentes en toda Latinoamérica
        </span>
        
        <h1 className="text-4xl md:text-6xl font-extrabold text-slate-900 tracking-tight leading-tight">
          Tu Éxito <br className="hidden md:inline" />
          Académico es <br />
          <span className="text-blue-600">Nuestro Compromiso</span>
        </h1>
        
        <p className="text-slate-500 mt-6 text-lg md:text-xl font-medium max-w-xl">
          Conectamos estudiantes con profesionales expertos.
        </p>

        {/* STATS */}
        <div className="grid grid-cols-3 gap-4 my-8 max-w-md mx-auto lg:mx-0 text-center lg:text-left border-y border-slate-100 py-4">
          <div>
            <div className="text-2xl md:text-3xl font-black text-blue-600">+10k</div>
            <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Servicios</div>
          </div>
          <div>
            <div className="text-2xl md:text-3xl font-black text-blue-600">+6 Años</div>
            <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Trayectoria</div>
          </div>
          <div>
            <div className="text-2xl md:text-3xl font-black text-blue-600">+100</div>
            <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Profesionales</div>
          </div>
        </div>

        {/* BOTONES DE ACCIÓN */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
          <a 
            href={constructorWhatsapp(numVentasPrincipal, "Hola, dese cotizar uno de sus servicios.")}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#10b981] hover:bg-emerald-600 text-white font-bold px-8 py-3.5 rounded-full shadow-lg shadow-emerald-100 flex items-center justify-center gap-2 transition-all transform hover:-translate-y-0.5 text-base"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
            </svg>
            Solicitar Servicio Ahora
          </a>
          <a 
            href= {portalClientes}
            target="_blank"
            rel="noopener noreferrer"
            className="border border-blue-600 text-blue-600 hover:bg-blue-50 font-bold px-8 py-3.5 rounded-full shadow-sm transition-all transform hover:-translate-y-0.5 flex items-center justify-center text-base"
          >
            Conocer Más / Portal
          </a>

        </div>

        {/* GARANTÍAS */}
        <div className="mt-8 flex flex-wrap justify-center lg:justify-start gap-x-6 gap-y-3 text-xs font-semibold text-slate-400">
          <span className="flex items-center gap-1.5">
            <svg className="w-4 h-4 text-emerald-500" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            100% Garantizado
          </span>
          <span className="flex items-center gap-1.5">
            <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            0% Plagio (Turnitin)
          </span>
          <span className="flex items-center gap-1.5">
            <svg className="w-4 h-4 text-purple-500" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Entrega Puntual
          </span>
          <span className="flex items-center gap-1.5">
            <svg className="w-4 h-4 text-cyan-500" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
            </svg>
            100% Humano (Anti-IA)
          </span>
        </div>
      </div>

      {/* COLUMNA DERECHA: DECK COMPACTO DE CALIFICACIONES COMPRIMIDAS */}
      <div className="relative w-full max-w-[440px] h-[450px] lg:mt-0 mt-6 origin-center">
        
        {/* Globo Verde de Calificación */}
        <div className="absolute top-0 right-4 bg-[#10b981] text-white py-1.5 px-3.5 rounded-xl shadow-md z-50 text-center font-bold text-xs">
          <span className="font-black">4.9 ★</span> Calificación Global
        </div>

        {/* CONTENEDOR ANCHOR */}
        <div className="absolute inset-0 scale-90 sm:scale-100">
          
          {/* TARJETA 1 */}
          <div className="absolute top-[20px] left-[10px] bg-white p-3 rounded-xl shadow-md border border-slate-100 w-[190px] z-10 transform -rotate-3 hover:scale-110 hover:z-50 transition-all duration-300">
            <div className="flex items-center gap-1.5 mb-1">
              <div className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-[9px] font-bold">AM</div>
              <div>
                <h4 className="text-[11px] font-bold text-slate-800">Ana María</h4>
                <p className="text-[8px] text-slate-400">U. Nacional</p>
              </div>
            </div>
            <div className="text-[8px] bg-blue-50 text-blue-700 font-bold px-1.5 py-0.5 rounded mb-0.5 inline-block">🔬 Turnitin: 0% Plagio</div>
            <p className="text-[8px] text-slate-500 leading-tight">"Filtro impecable, total originalidad."</p>
          </div>

          {/* TARJETA 2 */}
          <div className="absolute top-[10px] left-[210px] bg-white p-3 rounded-xl shadow-md border border-slate-100 w-[190px] z-20 transform rotate-2 hover:scale-110 hover:z-50 transition-all duration-300">
            <div className="flex items-center gap-1.5 mb-1">
              <div className="w-6 h-6 bg-pink-500 text-white rounded-full flex items-center justify-center text-[9px] font-bold">SP</div>
              <div>
                <h4 className="text-[11px] font-bold text-slate-800">Sofía P.</h4>
                <p className="text-[8px] text-slate-400">U. Católica</p>
              </div>
            </div>
            <div className="text-[8px] bg-purple-50 text-purple-700 font-bold px-1.5 py-0.5 rounded mb-0.5 inline-block">🔮 Nota: 4.6</div>
            <p className="text-[8px] text-slate-500 italic leading-tight">"Ensayo académico excelente"</p>
          </div>

          {/* TARJETA 3 */}
          <div className="absolute top-[125px] left-[0px] bg-white p-3 rounded-xl shadow-md border border-slate-100 w-[200px] z-30 transform -rotate-1 hover:scale-110 hover:z-50 transition-all duration-300">
            <div className="flex items-center gap-1.5 mb-1">
              <div className="w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center text-[9px] font-bold">DF</div>
              <div>
                <h4 className="text-[11px] font-bold text-slate-800">Diego F.</h4>
                <p className="text-[8px] text-slate-400">U. de Chile</p>
              </div>
            </div>
            <div className="text-[8px] bg-amber-50 text-amber-700 font-bold px-1.5 py-0.5 rounded mb-0.5 inline-block">📊 Nota: 4.7</div>
            <p className="text-[8px] text-slate-500 leading-tight">"Proyecto de investigación perfecto"</p>
          </div>

          {/* TARJETA 4 */}
          <div className="absolute top-[115px] left-[215px] bg-white p-3 rounded-xl shadow-md border border-slate-100 w-[195px] z-35 transform rotate-3 hover:scale-110 hover:z-50 transition-all duration-300">
            <div className="flex items-center gap-1.5 mb-1">
              <div className="w-6 h-6 bg-indigo-500 text-white rounded-full flex items-center justify-center text-[9px] font-bold">LM</div>
              <div>
                <h4 className="text-[11px] font-bold text-slate-800">Luis M.</h4>
                <p className="text-[8px] text-slate-400">U. de Bogotá</p>
              </div>
            </div>
            <div className="text-[8px] bg-emerald-50 text-emerald-700 font-bold px-1.5 py-0.5 rounded mb-0.5 inline-block">🎓 Nota: 4.9</div>
            <p className="text-[8px] text-slate-500 italic leading-tight">"Tesis aprobada con honores"</p>
          </div>

          {/* TARJETA 5 */}
          <div className="absolute top-[235px] left-[15px] bg-white p-3 rounded-xl shadow-md border border-slate-100 w-[190px] z-25 transform -rotate-3 hover:scale-110 hover:z-50 transition-all duration-300">
            <div className="flex items-center gap-1.5 mb-1">
              <div className="w-6 h-6 bg-emerald-500 text-white rounded-full flex items-center justify-center text-[9px] font-bold">JR</div>
              <div>
                <h4 className="text-[11px] font-bold text-slate-800">Javier R.</h4>
                <p className="text-[8px] text-slate-400">U. Nacional</p>
              </div>
            </div>
            <div className="text-[8px] bg-red-50 text-red-600 font-bold px-1.5 py-0.5 rounded mb-0.5 inline-block">⏱️ Nota: 4.8</div>
            <p className="text-[8px] text-slate-500 leading-tight">"Parcial de Estadística perfecto"</p>
          </div>

          {/* TARJETA 6 */}
          <div className="absolute top-[225px] left-[210px] bg-white p-3 rounded-xl shadow-md border border-slate-100 w-[200px] z-40 transform rotate-1 hover:scale-110 hover:z-50 transition-all duration-300">
            <div className="flex items-center gap-1.5 mb-1">
              <div className="w-6 h-6 bg-purple-600 text-white rounded-full flex items-center justify-center text-[9px] font-bold">CR</div>
              <div>
                <h4 className="text-[11px] font-bold text-slate-800">Cristian R.</h4>
                <p className="text-[8px] text-slate-400">Plataforma UNAD</p>
              </div>
            </div>
            <div className="text-[8px] bg-cyan-50 text-cyan-700 font-bold px-1.5 py-0.5 rounded mb-0.5 inline-block">💻 Aprobado 100%</div>
            <p className="text-[8px] text-slate-500 leading-tight">"Manejo confiable, muy buena nota."</p>
          </div>

          {/* BADGE DE PAÍSES COHESIVO AL FINAL DEL DECK */}
          <div className="absolute top-[325px] left-[110px] bg-white/95 backdrop-blur-sm px-4 py-2 rounded-xl border border-slate-100 shadow-md flex items-center justify-center gap-2 text-xs font-bold text-slate-600 z-45 transform hover:scale-105 transition-all">
            <span>🇨🇴 🇲🇽 🇦🇷 🇨🇱 🇵🇪 🇪🇨</span>
            <span className="text-slate-300 font-light">|</span>
            <span className="text-slate-400 font-medium">8 Países</span>
          </div>

        </div>
      </div>

    </section>
  );
};

export default Hero;